import { render } from "./CoAdminRightView.vue?vue&type=template&id=7b24d5a4"
import script from "./CoAdminRightView.vue?vue&type=script&lang=js"
export * from "./CoAdminRightView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__